import Vuex from "vuex"
import Vue from 'vue'
import os from './os'
import user from './user';
import activity from './activity';
import dialog from './dialog';
import header from './header';
import pickFault from './pickFault';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    os: os,
    user,
    activity,
    dialog,
    header,
    pickFault,
  }
})


// WEBPACK FOOTER //
// ./src/store/index.js